import { render } from "./SearchPerson.vue?vue&type=template&id=38538262"
import script from "./SearchPerson.vue?vue&type=script&lang=js"
export * from "./SearchPerson.vue?vue&type=script&lang=js"

import exportComponent from "/Users/robo1/Documents/Admin/admv5-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__